import AutoExclusionsPage from './AutoExclusionsPage';

export default AutoExclusionsPage;
